import { wrapWebPublishableData } from "../AuthData/WebPublishableData";
import { findChildMedia } from "../../helpers/helpers";
const shimmerProps = { height: "387px" };

export function ChildPhoto(props) {
  const { childMedia, childData } = props;

  const childPhotoUrl =
    findChildMedia(childMedia, (item) => {
      return item.format === "web" && item.contentTypeCode === "CGP" && (!item.subtypeCode || item.subtypeCode === "");
    })?.url || "";

  const girlSilhouette =
    "https://wvusstatic.com/images/childsilhouette_girl.svg";
  const boySilhouette = "https://wvusstatic.com/images/childsilhouette_boy.svg";

  const defaultPhotoUrl =
    childData?.gender?.toLowerCase() === "female"
      ? girlSilhouette
      : boySilhouette;

  const photoUrl = childPhotoUrl || defaultPhotoUrl;

  return (
    <>
      <img className="tile__img" src={photoUrl} alt="profile" />
    </>
  );
}

export default wrapWebPublishableData(ChildPhoto, { shimmerProps });
